import { fetchData } from 'Utils/fetch-data';
import { UserEvaluationI } from 'types';

class UserEvaluationApi {
  private endpoint: string = '/user-evaluations';

  /**
   * Método para obtener las evaluaciones de un empleado de un curso en específico
   * @param courseId
   * @param userId
   */
  async getUserEvaluationsByCourseId(courseId: string, userId: string) {
    const response = await fetchData<Array<UserEvaluationI>>(`${this.endpoint}/course/${courseId}/user/${userId}`, {
      method: 'GET',
    });

    return response;
  }
}

const userEvaluationApi = new UserEvaluationApi();

export default userEvaluationApi;
